/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.0
=========================================================

* Product Page: https://material-ui.com/store/items/soft-ui-pro-dashboard/
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";
import { useState, useEffect } from "react";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Settings page components
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Link from "@mui/material/Link";
import axios from "axios";
import JsonView from "react18-json-view";
// Auth service
import { auth } from "../../../utils/firebase.utils";
import { useAuthState } from "react-firebase-hooks/auth";

function StripeResults() {
  const [status, setStatus] = useState("Undefined");
  const [response, setResponse] = useState();   
    
  const [user, loading] = useAuthState(auth);

  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const success = urlParams.get('success');
    const canceled = urlParams.get('canceled')
    const sessionId = urlParams.get('session_id');

    if(success)
    {
      setStatus("Success");
    }
    else if(canceled)
    {
      setStatus("Canceled");
    }

    axios.post(`/stripe/update-subscription`, {sessionId: sessionId, uid: user.uid});

    axios.get(`/stripe/session-status?session_id=${sessionId}`)
      .then((res) => {
        console.log(res.data);
        setResponse(res.data);
      });
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <SoftBox mt={4}>
        <Grid container spacing={3}>
            <Grid item xs={12} lg={12}>
              <JsonView 
                    src={response} 
                    theme={'default'} 
                />
            </Grid>
        </Grid>
      </SoftBox>
    </DashboardLayout>
  );
}

export default StripeResults;
